import React from 'react';
import classNames from 'classnames/bind';
import { Swiper, SwiperSlide } from 'swiper/react';
import { compose } from '@beef/redux';
import PropTypes from 'prop-types';
import { Pagination } from '@carnica/ui-kit';
import { withRenderFlag } from '@beef/react';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect } from "../../utils";
import { useCarousel } from "./useCarousel";
import styles from "./styles.pcss";
import { CarouselWrapper } from "./components/CarouselWrapper";
import { Navigation as _Navigation } from "./components/Navigation";
import { Header as _Header } from "./components/Header";
import { CarouselSlide } from "./components/CarouselSlide";
import { CarouselContainer } from "./components/CarouselContainer";
var cx = classNames.bind(styles);
var DEFAULT_SLIDER_INDEX = 1;
var Header = withRenderFlag(_Header);
var Navigation = withRenderFlag(_Navigation);
var _WhyBeelineCarousel = function _WhyBeelineCarousel(_ref) {
  var children = _ref.children,
    title = _ref.title,
    text = _ref.text,
    className = _ref.className;
  var slidesLength = React.Children.count(children);
  var _useCarousel = useCarousel({
      slidesLength: slidesLength
    }),
    isDesktop = _useCarousel.isDesktop,
    nextSlide = _useCarousel.nextSlide,
    prevSlide = _useCarousel.prevSlide,
    setInstance = _useCarousel.setInstance,
    handleChangeSlide = _useCarousel.handleChangeSlide,
    handleManualSlideChange = _useCarousel.handleManualSlideChange,
    activeSlide = _useCarousel.activeSlide,
    activeIndex = _useCarousel.activeIndex;
  var isStartSlider = activeSlide === DEFAULT_SLIDER_INDEX;
  var isEndSlider = slidesLength ? activeSlide === slidesLength : false;
  return /*#__PURE__*/React.createElement(CarouselWrapper, {
    className: className,
    footer: /*#__PURE__*/React.createElement(Pagination, {
      activePoint: activeSlide,
      className: cx('pagination'),
      direction: "row",
      onPointClick: function onPointClick(point) {
        return handleManualSlideChange(point - 1);
      },
      points: slidesLength
    }),
    header: /*#__PURE__*/React.createElement(Header, {
      text: text,
      title: title,
      shouldRender: !isDesktop
    }),
    "data-t-id": "components-WhyBeelineCarousel"
  }, /*#__PURE__*/React.createElement(Navigation, {
    prevSlide: prevSlide,
    nextSlide: nextSlide,
    isStartSlider: isStartSlider,
    isEndSlider: isEndSlider,
    title: title,
    text: text,
    shouldRender: isDesktop
  }), /*#__PURE__*/React.createElement(CarouselContainer, null, /*#__PURE__*/React.createElement(Swiper, {
    centeredSlides: true,
    onSlideChange: setInstance,
    onSwiper: setInstance,
    slidesPerView: "auto",
    spaceBetween: 0,
    "data-t-id": "components-WhyBeelineCarousel"
  }, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      className: cx('slide')
    }, /*#__PURE__*/React.createElement(CarouselSlide, {
      index: index,
      isActive: index === activeIndex,
      onClick: function onClick() {
        return handleChangeSlide(index);
      },
      "data-t-id": "components-WhyBeelineCarousel"
    }, child));
  }))));
};
export var WhyBeelineCarousel = compose(enhancedConnect({
  children: PropTypes.node,
  text: PropTypes.string,
  title: PropTypes.string
}), withAutoMetric.Container(function () {
  return {
    name: 'WhyBeelineCarousel'
  };
}))(_WhyBeelineCarousel);